<template>
	<div id="app" class="bausim" ref="app">
		<div>
			<div>
				<div>BauSim</div>
				<div>
					<ul>
						<li @click="goTo('services')">Služby</li>
						<li @click="goTo('references')">Referencie</li>
						<li @click="goTo('form')">Cennová ponuka</li>
						<li @click="goTo('contact')">Kontakt</li>
					</ul>
				</div>
				<div ref="dropDown">
					<i class="fa fa-bars" @click="open = !open"></i>
					<ul v-if="open">
						<li @click="goTo('services')">Služby</li>
						<li @click="goTo('references')">Referencie</li>
						<li @click="goTo('form')">Cennová ponuka</li>
						<li @click="goTo('contact')">Kontakt</li>
					</ul>
				</div>
			</div>
		</div>

		<div>
			<img src="./assets/banner.png">
			<div>
				<span>Tam kde ostatní vidia problém,<br>
					my vidíme príležitosť.</span>
			</div>
		</div>

		<div>
			<div>
				<p>Drobný popis k firme. Napr. kedy ako kde a čo viedlo k vzniku firmy. A nejaké teplé slová k tomu.</p>
				<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse posuere venenatis mauris ac suscipit.
					Proin lectus tortor, feugiat id mauris ut, pretium finibus turpis. Maecenas faucibus faucibus posuere.
					Integer sed volutpat felis. Pellentesque pretium diam quis eros dignissim dignissim.</p>
			</div>
		</div>

		<div ref="services">
			<div>
				<h2>Služby</h2>
				<div>
					<h3>Čistenie kanalizačných systémov</h3>
					<i class="fa fa-chevron-down" @click="showServices"></i>
					<p>Loremipsum dolorsit  sadsad ssamet, consectetur adipisadsscing elit. Suspendisse posuere venenatis mauris ac suscipit.
						Proin lectus tortor, feugiat id mauris utconsectetur adipiscing elit.</p>
				</div>
				<div>
					<h3>Prípravné práce k realizácii stavby</h3>
					<i class="fa fa-chevron-down" @click="showServices"></i>
					<p>Maecenas faucibus faucibus posuere. Integsadd dsdsaer sed volutpat felis.
						Pellentesque pretium diam quis eros dignissim dignissim.</p>
				</div>
				<div>
					<h3>Uskutočňovanie stavieb a ich zmien</h3>
					<i class="fa fa-chevron-down" @click="showServices"></i>
					<p>Proin lectus tortor. Maecenas faucibus faucibus posuere. Integer sed volutpat felis.
						Pellentesque pretium diam quis eros dignissim dignissim.</p>
				</div>
				<div>
					<h3>Dokončovacie stavebné práce pri realizácii exteriérov a interiérov</h3>
					<i class="fa fa-chevron-down" @click="showServices"></i>
					<p>Suspendisse posuere venenatis mauris ac suscipit. Proin lectus tortor,
						feugiat id mauris ut, pretium finibus turpis. Maecenas faucibus faucibus.</p>
				</div>
				<div>
					<h3>Inžinierska činnosť, stavebné cenárstvo</h3>
					<i class="fa fa-chevron-down" @click="showServices"></i>
					<p>Venenatis mauris ac suscipit. Proin lectus tortor, feugiat id mauris ut, pretium finibus turpis. Maecenas faucibus faucibus.</p>
				</div>
				<div>
					<h3>Projektovanie a konštruovanie elektrických zariadení</h3>
					<i class="fa fa-chevron-down" @click="showServices"></i>
					<p>Ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse posuere venenatis mauris ac suscipit. Proin lectus tortor,
						feugiat id mauris utconsectetur adipiscing eli Proin lectus tortor, feugiat id mauris ut, pretium finibus turpis.</p>
				</div>
			</div>
		</div>

		<div ref="form">
			<div>
				<div>
					<h2 @click="goTo('services')">Cennová ponuka</h2>
					<p>Napíšte nám Vašu požiadavku a my Vám spravíme cennovú ponuku na mieru</p>
				</div>
				<div novalidate onsubmit="event.preventDefault();">
					<label>
						<span>Meno a priezvisko</span>
						<input type="text" placeholder="meno a priezvisko..." v-model="mailData.formatedName" require>
					</label>
					<label>
						<span>E-mail</span>
						<input type="text" placeholder="e-mail..." v-model="mailData.email" require>
					</label>
					<label>
						<span>Text požiadavky</span>
						<textarea placeholder="text požiadavky..." v-model="mailData.text" require></textarea>
					</label>
					<button @click="sendMail">Odoslať</button>
				</div>
			</div>
		</div>

		<div ref="references">
			<div>
				<h2>Referencie</h2>
				<p>Realizovali sme stavby od tatier k dunaju. V tom čo robíme sme najlepší.</p>
				<p>Medzi našich spokojních zákazníkov patrí napríklad Ten a Ten. Praesent quam ante, tincidunt vitae enim vitae,
					tempus vulputate augue. Sed ullamcorper porttitor felis, ut ornare felis rhoncus fringilla. Maecenas vitae sodales turpis.</p>
				<ul>
					<li>
						<div>
							<img src="./assets/references1.jpg" alt=""/>
						</div>
					</li>
					<li>
						<div>
							<img src="./assets/references2.jpg" alt=""/>
						</div>
					</li>
					<li>
						<div>
							<img src="./assets/references3.jpg" alt=""/>
						</div>
					</li>
					<li>
						<div>
							<img src="./assets/references4.jpg" alt=""/>
						</div>
					</li>
					<li class="pusher"></li>
					<li>
						<div>
							<img src="./assets/references5.jpg" alt=""/>
						</div>
					</li>
					<li>
						<div>
							<img src="./assets/references6.jpeg" alt=""/>
						</div>
					</li>
					<li>
						<div>
							<img src="./assets/references7.jpg" alt=""/>
						</div>
					</li>
					<li>
						<div>
							<img src="./assets/references8.jpg" alt=""/>
						</div>
					</li>
				</ul>
			</div>
		</div>

		<div ref="contact">
			<div>
				<div>
					<h2>Kontakt</h2>
					<div>
						<i class="fa fa-home"></i>
						<span>Nitrianska 704<br>
							925 51 Šintava</span>
						<span>IČO: 50 345 605<br>
							DIČ: 212 000 0000</span>
					</div>
					<div>
						<i class="fa fa-phone"></i>
						<a href="tel:0911 111 111">0911 111 111</a>
						<a href="tel:0911 111 111">0911 111 111</a>
					</div>
					<div>
						<i class="fa fa-envelope"></i>
						<a href="mailto:bausim@bausim.sk">bausim@bausim.sk</a>
					</div>
				</div>
			</div>
		</div>

		<div>
			<div>
				<h2>Napíšte nám</h2>
				<div novalidate onsubmit="event.preventDefault();">
					<label>
						<input type="text" placeholder="meno a priezvisko..." v-model="mailData.formatedName" require>
					</label>
					<label>
						<input type="text" placeholder="e-mail..." v-model="mailData.email" require>
					</label>
					<label>
						<textarea placeholder="text požiadavky..." v-model="mailData.text" require></textarea>
					</label>
					<button @click="sendMail">Odoslať</button>
				</div>
			</div>
		</div>

		<div>
			© 2018 BAUSIM, s.r.o, Všetky práva vyhradené
		</div>
	</div>
</template>

<script>
	import "font-awesome/scss/font-awesome.scss";
	import Axios from "axios";

	export default {
		name: "app",
		data() {
			return {
				open: false,
				mailData: {
					formatedName: null,
					email: null,
					text: null,
				},
			};
		},
		methods: {
			documentClick(e) {
				const el = this.$refs.dropDown;
				const target = e.target;
				if (el && el !== target && !el.contains(target)) {
					this.open = false;
				}
			},
			goTo(ref) {
				window.scrollTo(0, this.$refs[ref].offsetTop);
				this.open = false;
			},
			showServices(event) {
				const el = event.srcElement;
				const paragraph = el.nextElementSibling;
				if (el.className.includes("down")) {
					el.classList.remove("fa-chevron-down");
					el.classList.add("fa-chevron-up");
					paragraph.style.display = "block";
				} else {
					el.classList.remove("fa-chevron-up");
					el.classList.add("fa-chevron-down");
					paragraph.style.display = "none";
				}
			},
			sendMail() {
				const config = {
					headers: {
						"Content-Type": "application/json",
					},
				};
				Axios.post("http://www.bausim.sk/api/sendMail.php", this.mailData, config);

				this.mailData.formatedName = null;
				this.mailData.email = null;
				this.mailData.text = null;
			},
		},
		created() {
			document.addEventListener("click", this.documentClick);
		},
		destroyed() {
			document.removeEventListener("click", this.documentClick);
		},
	};
</script>

<style lang="scss">
	@font-face {
		font-family: "Roboto";
		src: local("Roboto Light"), local("Roboto-Light"),
			url("../node_modules/roboto-fontface/fonts/roboto/Roboto-Light.woff2") format("woff2"),
			url("../node_modules/roboto-fontface/fonts/roboto/Roboto-Light.woff") format("woff");
		font-weight: 300;
		font-style: normal;
	}
	@font-face {
		font-family: "Roboto";
		src: local("Roboto Regular"), local("Roboto-Regular"),
			url("../node_modules/roboto-fontface/fonts/roboto/Roboto-Regular.woff2") format("woff2"),
			url("../node_modules/roboto-fontface/fonts/roboto/Roboto-Regular.woff") format("woff");
		font-weight: 400;
		font-style: normal;
	}
	@font-face {
		font-family: "Roboto";
		src: local("Roboto Medium"), local("Roboto-Medium"),
			url("../node_modules/roboto-fontface/fonts/roboto/Roboto-Medium.woff2") format("woff2"),
			url("../node_modules/roboto-fontface/fonts/roboto/Roboto-Medium.woff") format("woff");
		font-weight: 500;
		font-style: normal;
	}

	html {
		font-family: "Roboto", Arial, Helvetica, sans-serif;
		height: 100%;
	}
	body {
		color: #333;
		font-size: 18px;
		font-weight: 300;
		line-height: 21px;
		margin: 0;
		.bausim {
			h2 {
				font-size: 36px;
				font-weight: 300;
				line-height: 42px;
				margin: 0 0 30px;
				text-align: center;
				width: 100%;
			}
			> div {
				&:first-of-type {
					> div {
						align-items: flex-end;
						display: flex;
						justify-content: space-between;
						margin: 30px auto 0;
						max-width: 1024px;
						div {
							&:first-of-type {
								font-size: 36px;
								font-weight: 300;
								line-height: 36px;
								margin-bottom: 15px;
							}
							&:nth-of-type(2) {
								ul {
									list-style: none;
									margin: 0 0 15px;
									li {
										cursor: pointer;
										display: inline;
										font-size: 18px;
										font-weight: 300;
										margin-right: 30px;
										&:last-of-type {
											margin-right: 0;
										}
									}
								}
							}
							&:last-of-type {
								display: none;
							}
						}
					}
				}
				&:nth-of-type(2) {
					img {
						width: 100%;
					}
					> div {
						margin: 0 auto;
						max-width: 1024px;
						position: relative;
						span {
							bottom: 50px;
							color: #fff;
							font-size: 36px;
							font-weight: 300;
							line-height: 42px;
							left: 5%;
							position: absolute;
						}
					}
				}
				&:nth-of-type(3) {
					> div {
						margin: 75px auto 0;
						max-width: 1024px;
						p {
							text-align: center;
						}
					}
				}
				&:nth-of-type(4) {
					> div {
						display: flex;
						flex-wrap: wrap;
						justify-content: space-between;
						margin: 75px auto 0;
						max-width: 1024px;
						> div {
							position: relative;
							margin: 0 0 30px;
							width: 30%;
							h3 {
								font-size: 18px;
								font-weight: 400;
								margin: 0 0 15px;
								text-align: center;
							}
							i {
								display: none;
								position: absolute;
								right: 10px;
								top: 0px;
							}
							p {
								text-align: justify;
							}
						}
					}
				}
				&:nth-of-type(5) {
					background: #2E2E2E;
					> div {
						color: #fff;
						display: flex;
						margin: 45px auto 0;
						max-width: 1024px;
						padding-bottom: 75px;
						padding-top: 75px;
						h2, p {
							padding-right: 50px;	
							text-align: left;
						}
						> div {
							width: 50%;
							&:last-of-type {
								label {
									display: block;
									margin-bottom: 10px;
									&:last-of-type {
										margin-bottom: 30px;
									}
									span {
										display: inline-block;
										vertical-align: top;
										width: 40%;
									}
									input, textarea {
										border: 0;
										font-size: 16px;
										font-weight: 300;
										padding: 10px 15px;
										width: 50%;
										&::placeholder {
											color: #333;
											font-size: 16px;
											font-weight: 300;
											opacity: 0.5;
										}
									}
									textarea {
										min-height: 100px;
									}
								}
								button {
									border: 0;
									background: #4A90E2;
									color: #fff;
									font-size: 18px;
									margin-left: calc(40% + 4px);
									min-width: 200px;
									padding: 10px 15px;
									text-align: center;
									text-transform: uppercase;
								}
							}
						}
					}
				}
				&:nth-of-type(6) {
					> div {
						margin: 75px auto 0;
						max-width: 1024px;
						p {
							text-align: center;
						}
						ul {
							overflow: hidden;
							padding: 20% 0 75px;
							width: 100%;
							margin: 0 auto;
							li {
								position: relative;
								list-style-type:none;
								padding-bottom: 25.7142857143%; /* = (100-2.5) / 3.5 -> upravene na 90/3.5*/
								width: 29.6931705708%; /* =  padding /0.866 */
    							margin-right: 16.8465852854%;
    							margin-bottom: 0.5%;
								margin-top: -12.8571428572%;
								float: left;
								overflow: hidden;
								visibility: hidden;
								transform: rotate(60deg) skewX(30deg);
								&:nth-child(4n+3) {
									margin-left: 1%;
								}
								&:nth-child(4n+3), &:nth-child(4n+4) {
									transform: translateX(75%) rotate(60deg) skew(30deg);
								}
								* {
									position: absolute;
									visibility: visible;
								}
								> div{
									width: 100%;
									height: 100%;
									text-align: center;
									color: #fff;
									overflow: hidden;
									transform: skewX(-30deg) rotate(-60deg);
									-webkit-backface-visibility:hidden;
								}
								img {
									left: -100%;
									right: -100%;
									width: auto;
									height: 100%;
									margin: 0 auto;   
								}
							}
							&:after{
								content:"";
								display:block;
								clear:both;
							}
						}
					}
				}
				&:nth-of-type(7) {
					background: url("./assets/maps.png");
					background-position: 100% 0;
					background-repeat: no-repeat;
					background-size: cover;
					height: 500px;
					> div {
						align-items: center;
						display: flex;
						height: 100%;
						margin: 0 auto;
						max-width: 1024px;
						> div {
							background: #fff;
							box-shadow: 0 3px 6px 1px rgba(0, 0, 0, 0.5);
							line-height: 24px;
							padding: 30px 30px 60px;
							width: 500px;
							h2 {
								margin-bottom: 15px;
							}
							> div {
								position: relative;
								i {
									font-size: 44px;
									position: absolute;
								}
								&:last-of-type i {
									font-size: 36px;
								}
								span {
									display: block;
									margin-bottom: 15px;
									margin-left: 90px;
								}
								a {
									color: #333;
									display: block;
									margin-left: 90px;
									text-decoration: none;
								}
								&:nth-of-type(2) {
									margin-bottom: 20px;
								}
							}
						}
					}
				}
				&:nth-of-type(8) {
					display: none;
				}
				&:last-of-type {
					background: #2E2E2E;
					color: #fff;
					font-size: 14px;
					padding: 15px 30px;
				}
			}
		}
	}
	@media only screen and (max-width: 1094px) {
		body .bausim {
			> div {
				> div {
					padding-left: 30px;
					padding-right: 30px;
				}
				&:nth-of-type(2) {
					> div span {
						bottom: 20px;
						font-size: 27px;
						line-height: 31px;
					}
				}
			}
		}
	}
	@media only screen and (max-width: 767px) {
		body .bausim {
			> div {
				&:nth-of-type(4) {
					> div > div {
						width: 45%;
					}
				}
				&:nth-of-type(5) {
					> div > div:last-of-type {
						label {
							span {
								display: none;
							}
							input, textarea {
								width: calc(100% - 30px);
							}
						}
						button {
							margin-left: 0;
							width: 100%;
						}
					}
				}
				&:nth-of-type(7) {
					background: #2e2e2e;
					height: auto;
					> div > div {
						background: none;
						box-shadow: none;
						color: #fff;
						margin: 50px 0;
						padding: 0;
						width: 100%;
						h2 {
							margin-bottom: 20px;
						}
						> div {
							float: left;
							width: 45%;
							a {
								color: #fff;
							}
							span, a {
								margin-left: 21%;
							}
							i {
								font-size: 32px;
								position: absolute;
							}
							&:last-of-type i {
								font-size: 28px;
							}
						}
					}
				}
				&:last-of-type {
					background: none;
					color: #333;
					font-size: 14px;
					padding: 15px 30px;
				}
			}
		}
	}
	@media only screen and (max-width: 660px) {
		body .bausim > div:first-of-type > div > div{
			&:nth-of-type(2) {
				display: none;
			}
			&:last-of-type {
				align-self: flex-start;
				cursor: pointer;
				display: block;
				i {
					font-size: 28px;
				}
				ul {
					background: #fff;
					list-style: none;
					margin: 0;
					padding: 0 15px;
					position: absolute;
					right: 30px;
					li {
						border-bottom: 1px solid #eee;
						padding: 5px 0;
						&:last-of-type {
							border: 0;
						}
					}
				}
			}
		}
	}
	@media only screen and (max-width: 540px) {
		body .bausim {
			> div {
				font-size: 14px;
				line-height: 16px;
				h2 {
					font-size: 18px;
					line-height: 21px;
					margin-bottom: 15px;
				}
				&:first-of-type {
					position: absolute;
					z-index: 9;
					> div > div {
						color: #fff;
						font-size: 24px;
						line-height: 28px;
						&:last-of-type {
							display: none;
						}
					}
				}
				&:nth-of-type(2) {
					span {
						display: none;
					}
				}
				&:nth-of-type(3) > div {
					margin-top: 30px;
				}
				&:nth-of-type(4) > div {
					margin-top: 30px;
					> div {
						margin-bottom: 20px;
						width: 100%;
						h3 {
							font-size: 14px;
							margin-bottom: 10px;
							text-align: left;
							width: calc(100% - 35px);
						}
						i {
							cursor: pointer;
							display: block;
						}
						p {
							display: none;
						}
					}
				}
				&:nth-of-type(5) {
					display: none;
				}
				&:nth-of-type(6) > div {
					margin-top: 10px;
					ul {
						display: none;
					}
				}
				&:nth-of-type(7) {
					background: none;
					> div > div {
						color: #333;
						margin-bottom: 30px;
						margin-top: 30px;
						> div {
							float: none;
							width: 100%;
							a, span {
								color: #333;
								margin-left: 70px;
							}
						}
					}
				}
				&:nth-of-type(8) {
					display: block;
					> div {
						margin-bottom: 30px;
						label {
							display: block;
							margin-bottom: 10px;
							&:last-of-type {
								margin-bottom: 15px;
							}
							input, textarea {
								border: 1px solid #ccc;
								font-size: 16px;
								font-weight: 300;
								padding: 10px 15px;
								width: calc(100% - 30px);
								&::placeholder {
									color: #333;
									font-size: 14px;
									font-weight: 300;
									opacity: 0.5;
								}
							}
							textarea {
								min-height: 100px;
							}
						}
						button {
							border: 0;
							background: #4A90E2;
							color: #fff;
							font-size: 14px;
							padding: 10px 15px;
							text-align: center;
							text-transform: uppercase;
							width: 100%;
						}
					}
				}
				&:last-of-type {
					background: #2E2E2E;
					color: #fff;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/App.vue